import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PublicLayout from './layouts/PublicLayout';
import ProtectedLayout from './layouts/ProtectedLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Head from './pages/Head';
import { LoadingProvider } from './context/LoadingContext';
import Loader from './components/Loader'; 
import Ledger from './pages/Ledger';
import Report from './pages/Report';
import HowToUse from './pages/HowToUse';
import CallUs from './pages/CallUs';
import AboutUs from './pages/AboutUs';
import Privacy from './pages/Privacy';
import Profile from './pages/Profile';
import TermsCondition from './pages/TermsCondition';
import './assets/css/custom.css';
import ProtectedRoute from './components/ProtectedRoute';
import Pricing from './pages/Pricing';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import ErrorPage from './pages/ErrorPage';
import AdminHead from './pages/admin/AdminHead';
import AdminLedger from './pages/admin/AdminLedger';
import AdminApprovalRequest from './pages/admin/AdminApprovalRequest';
import AdminUser from './pages/admin/AdminUser';
// import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <AuthProvider>
      <LoadingProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/" element={<PublicLayout />}>
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
            </Route>
            <Route path="pricing" element={<Pricing />} />
            <Route element={<ProtectedRoute><ProtectedLayout /></ProtectedRoute>}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="heads" element={<Head />} />
              <Route path="ledgers" element={<Ledger />} />
              <Route path="profiles" element={<Profile />} />
              <Route path="reports" element={<Report />} />
              <Route path="how-to-use" element={<HowToUse />} />
              <Route path="call-us" element={<CallUs />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="privacy-policy" element={<Privacy />} />
              <Route path="terms-conditions" element={<TermsCondition />} />
            </Route>
            {/* Admin Routes */}
            <Route path="admin" element={<AdminProtectedRoute><ProtectedLayout /></AdminProtectedRoute>}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<AdminUser />} />
                <Route path="heads" element={<AdminHead />} />
                <Route path="ledgers" element={<AdminLedger />} />
                <Route path="approval-requests" element={<AdminApprovalRequest />} />
            </Route>
            <Route path="error/:errorCode" element={<ErrorPage />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Router>
        <Loader />
      </LoadingProvider>
    </AuthProvider>
  );
};

export default App;